export default "__VITE_ASSET__DLhlpoWe__"